import { Box, useTheme } from "@mui/material";

import { UnstyledLink } from "./Routing/UnstyledLink";

export const LogoCollapsed = (): React.ReactNode => {
  const theme = useTheme();
  return (
    <UnstyledLink to="/">
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          component="img"
          alt="vivelo.ai"
          src="/images/logo-mark.svg"
          sx={{
            height: theme.spacing(8),
            width: "auto",
          }}
        />
      </Box>
    </UnstyledLink>
  );
};
